export default "__VITE_ASSET__$4VTsGrl__"